import {
  CASE_CREATE_TIMELINES_BEGIN,
  CASE_CREATE_TIMELINES_SUCCESS,
  CASE_CREATE_TIMELINES_FAILURE,
  CASE_CREATE_TIMELINES_DISMISS_FEEDBACK,
} from './constants';
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  createPromiseAction,
  resolvePromiseAction,
  rejectPromiseAction,
} from '@adobe/redux-saga-promise';
import api from 'common/api';
import { withCurrentCaseId } from '../../../common/selectors';

export const createTimelines = createPromiseAction(CASE_CREATE_TIMELINES_BEGIN);

export function dismissCreateTimelinesFeedback() {
  return {
    type: CASE_CREATE_TIMELINES_DISMISS_FEEDBACK,
  };
}

export function* doCreateTimelines(action) {
  const { caseId, timelines } = action.payload;
  let res = yield call(api.post, `/cases/${caseId}/timelines`, timelines);

  if (res && res.error) {
    yield put({
      type: CASE_CREATE_TIMELINES_FAILURE,
      feedback: {
        message: 'feedback.createTimelinesFailure',
        error: res.error,
        retryAction: action,
      },
    });
    return yield call(rejectPromiseAction, action, res.error);
  }

  yield put({
    type: CASE_CREATE_TIMELINES_SUCCESS,
    data: { timelines: res },
  });
  yield call(resolvePromiseAction, action, res);
}

export function* watchCreateTimelines() {
  yield takeLatest(createTimelines, withCurrentCaseId(doCreateTimelines));
}

export function reducer(state, action) {
  switch (action.type) {
    case CASE_CREATE_TIMELINES_BEGIN + '.TRIGGER':
      // Just after a request is sent
      return {
        ...state,
        createTimelinesPending: true,
        createTimelinesFeedback: null,
      };

    case CASE_CREATE_TIMELINES_SUCCESS:
      // The request is success
      return {
        ...state,
        createTimelinesPending: false,
        createTimelinesFeedback: action.feedback,
      };

    case CASE_CREATE_TIMELINES_FAILURE:
      // The request is failed
      return {
        ...state,
        createTimelinesPending: false,
        createTimelinesFeedback: action.feedback,
      };

    case CASE_CREATE_TIMELINES_DISMISS_FEEDBACK:
      // Dismiss the request failure error
      return {
        ...state,
        createTimelinesFeedback: null,
      };

    default:
      return state;
  }
}
